import axios from 'axios'
import { getToken } from '@/utils/getToken'
import { Message } from 'element-ui'
import { serialize } from "@/utils";
import qs from "qs";

// 创建axios实例
const request = axios.create({
  // 这里可以放一下公用属性等。
  baseURL: "/dev-api", // 用于配置请求接口公用部分，请求时会自动拼接在你定义的url前面。
  withCredentials: false, // 跨域请求时是否需要访问凭证
  timeout: 100 * 1000, // 请求超时时间

})
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 请求拦截器
request.interceptors.request.use((config) => {
  config.headers['Content-Type'] = "application/json; charset=UTF-8";
  //token名称以自己的为定，我的是‘satoken’，如果不需要if这里就可以直接删掉
  const isToken = (config.headers || {}).isToken === false;
  const token = getToken("token");
  if (token && !isToken) {
    config.headers["Authorization"] = "Bearer " + JSON.parse(getToken("token")).token; // token
    // config.data.token = token;
  }

  // headers中配置serialize为true开启序列化
  if (config.method === "post" && config.headers.serialize) {
    config.data = serialize(config.data);
    delete config.data.serialize;
  }

  if (config.method === "get") {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    };
  }
  return config;
}, (error) => {
  return Promise.reject(error)
})

request.interceptors.response.use((response) => {
  //返回码以自己的为定，如果没有安装elementui就换成自己的提示
  let { code, msg, result } = response.data
  if (code != 200) {
    Message.error(msg);
  }
  return response.data;
}, (error) => {
  return Promise.reject(error)
})

export default request;//记得暴露出去